import * as Types from '../../../../../__generated__/schema';

import { UserDetails } from '../../../../graphql/fragments/UserDetails.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListUsersRolesSamlVariables = Types.Exact<{ [key: string]: never }>;

export type ListUsersRolesSaml = {
  users: Array<UserDetails>;
  samlConfig: Pick<Types.SamlConfig, 'defaultRoleId'>;
  roles: Array<Pick<Types.Role, 'id' | 'name'>>;
};

export const ListUsersRolesSamlDocument = gql`
  query ListUsersRolesSaml {
    users {
      ...UserDetails
    }
    samlConfig {
      defaultRoleId
    }
    roles {
      id
      name
    }
  }
  ${UserDetails}
`;

/**
 * __useListUsersRolesSaml__
 *
 * To run a query within a React component, call `useListUsersRolesSaml` and pass it any options that fit your needs.
 * When your component renders, `useListUsersRolesSaml` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersRolesSaml({
 *   variables: {
 *   },
 * });
 */
export function useListUsersRolesSaml(
  baseOptions?: Apollo.QueryHookOptions<ListUsersRolesSaml, ListUsersRolesSamlVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersRolesSaml, ListUsersRolesSamlVariables>(
    ListUsersRolesSamlDocument,
    options,
  );
}
export function useListUsersRolesSamlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListUsersRolesSaml, ListUsersRolesSamlVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersRolesSaml, ListUsersRolesSamlVariables>(
    ListUsersRolesSamlDocument,
    options,
  );
}
export function useListUsersRolesSamlSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersRolesSaml, ListUsersRolesSamlVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersRolesSaml, ListUsersRolesSamlVariables>(
    ListUsersRolesSamlDocument,
    options,
  );
}
export type ListUsersRolesSamlHookResult = ReturnType<typeof useListUsersRolesSaml>;
export type ListUsersRolesSamlLazyQueryHookResult = ReturnType<
  typeof useListUsersRolesSamlLazyQuery
>;
export type ListUsersRolesSamlSuspenseQueryHookResult = ReturnType<
  typeof useListUsersRolesSamlSuspenseQuery
>;
export type ListUsersRolesSamlQueryResult = Apollo.QueryResult<
  ListUsersRolesSaml,
  ListUsersRolesSamlVariables
>;
export function mockListUsersRolesSaml({
  data,
  variables,
  errors,
}: {
  data: ListUsersRolesSaml;
  variables?: ListUsersRolesSamlVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListUsersRolesSamlDocument, variables },
    result: { data, errors },
  };
}
